export const ru = {
    'select-empty': 'Незаполненные поля'
};
